import React, {useState, useEffect } from 'react'

function AutoCompleteList({valueSetter, keyPressed, setItemClicked, items}) {
  const [activeItemIndex, setActiveItemIndex] = useState(-1)
  const [prevItemIndex, setPrevItemIndex] = useState(0)

  const onClickItem = (e) => {
    valueSetter(e.target.textContent)
    setItemClicked(true)
  }

  function highlightActiveItem() {
    if (activeItemIndex === -1) {
      const prevActiveElement = document.getElementById((prevItemIndex).toString())
      prevActiveElement.classList.remove('active-item')
      return
    }
    // Remove previous active item hightlight
    const prevActiveElement = document.getElementById((prevItemIndex).toString())
    prevActiveElement.classList.remove('active-item')

    // Highlight the current active item
    const currentActiveElement = document.getElementById((activeItemIndex).toString())
    currentActiveElement.classList.add('active-item')

    // currentActiveElement.scrollIntoView(false)
    currentActiveElement.scrollIntoView({block: 'nearest'})

    // Set the current control value
    valueSetter(currentActiveElement.textContent)
  }

  useEffect(() => {
    // Each scroll
    highlightActiveItem()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeItemIndex])

  useEffect(() => {
    switch(keyPressed) {
      case 'ArrowUp':
        if (activeItemIndex === -1) return
        // Decrement pointer
        setPrevItemIndex(activeItemIndex)
        setActiveItemIndex(prev => prev - 1)
        break;
      case 'ArrowDown':
        if (activeItemIndex === (items.length - 1)) return
        if (activeItemIndex === -1)
          setPrevItemIndex(0)
        else
          setPrevItemIndex(activeItemIndex)
        setActiveItemIndex(prev => prev + 1)
        break;
      default:
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyPressed])

  return (
    <React.Fragment>
      <div id='autocomplete-list'>
        {
          items.map((item, index) => (
            <div
              key={index}
              id={index}
              onClick={onClickItem}
              className='autocomplete-list-item'>
              {item}
            </div>
          ))
        }
      </div>
      <style jsx='true'>
        {`
          /* AUTOCOMPELETE LIST */
          #autocomplete-list {
            margin: 0;
            position: absolute;
            border: solid 1px blue;
            background-color: white;
            /*font-size: 15px;*/
            /*width: 44.9%;*/
            width: 100%;
            color: rgba(33,33,33,1);
            box-sizing: border-box;
            /*margin-top: 33px;*/
            /*margin-left: 10%;*/
            /*margin-left: 137px;*/
            overflow: auto;
            max-height: 100px;
            z-index: 99;
          }
          .autocomplete-list-item {
            padding: 5px;
          }
          .active-item {
            background-color: DodgerBlue;
            color: whitesmoke;
          }
          .autocomplete-list-item:hover {
            background-color: #222;
            cursor: pointer;
            color: whitesmoke;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default AutoCompleteList
